import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const themeColorSlice = createSlice({
  name: 'themeColor',
  initialState: {
    loading:false,
    landingPageWord:''
   
  },
  reducers: {
    
    setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
      setLandingPageWordRedux: (state, action) => {
        const { landingPageWord } = action.payload
        state.landingPageWord = landingPageWord
      }
      
  },
})

export default themeColorSlice.reducer;

export const {
    setLoadingRedux,
    setLandingPageWordRedux
   
  
} = themeColorSlice.actions

export const getLoadingRedux = (state) => state.themeColor.loading
export const getLandingPageWordRedux = (state) => state.themeColor.landingPageWord



